import axios from 'axios';

const rawBackendUrl = process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? 'http://localhost:8000' : '');
const API_BASE = rawBackendUrl ? `${rawBackendUrl.replace(/\/$/, '')}/api` : '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor for 401 Unauthorized Session Expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/signup')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Error detail formatter
export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : (typeof e === "string" ? e : JSON.stringify(e))))
      .filter(Boolean)
      .join(" ");
  }
  if (typeof detail === "object") {
    if (typeof detail.msg === "string") return detail.msg;
    if (typeof detail.message === "string") return detail.message;
    if (typeof detail.error === "string") return detail.error;
    return JSON.stringify(detail);
  }
  return String(detail);
}

// INR formatter
export function formatINR(amount) {
  if (amount == null || isNaN(amount)) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    maximumFractionDigits: 0,
  }).format(amount);
}

// Area formatter
export function formatArea(sqm) {
  const sqft = (sqm * 10.764).toFixed(2);
  return `${sqm.toFixed(3)} Sqm (${sqft} Sq.ft)`;
}

export const SQM_TO_SQFT = 10.764;

export default api;
